// QualificationDropdown.jsx
import React from "react";

const QualificationDropdown = ({ label, options, onChange }) => {
  return (
    <div className="form-group">
      <div className="floating-label tp-dropdown">
        <select className="form-control" onChange={onChange}>
          <option value="">Select option</option>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
        <label className="focused">
          {label} <sup className="text-danger">*</sup>
        </label>
      </div>
      <p className="err text-danger"></p>
      <input type="hidden" />
    </div>
  );
};

export default QualificationDropdown;
